import { useQueryWithSimpleErrorHandling } from '@ts-private/apollo-tools';
import { emptyFunction } from 'utils/constants';
import { ServiceContext } from 'providers/ServiceProvider';
import { useContext } from 'react';
import { useSimpleError } from 'hooks/apolloWrappers';

const useQuery = (query, options) => {
  // extract custom options
  const { onError = emptyFunction, ...restOptions } = options || {};
  const [activeService] = useContext(ServiceContext);
  const showError = useSimpleError();

  return useQueryWithSimpleErrorHandling(query, {
    notifyOnNetworkStatusChange: true,
    ...restOptions,
    context: { serviceName: activeService?.name },
    onError: error => {
      onError(error);
      showError(error);
    },
    skip: restOptions?.skip || !activeService?.name
  });
};

export default useQuery;
